// VAPID public key для Web Push (VAPID) подписки в браузере.
//
// Ключ хранится в Novu Dashboard → Integrations → Web Push и форвардится во
// фронт через build-time env `VITE_VAPID_PUBLIC_KEY` (см. apps/web/.env.example
// и серверный `NOVU_VAPID_PUBLIC_KEY` в shared/config/load.ts). Должен совпадать
// с публичным ключом, которым Novu подписывает доставку — иначе браузер примет
// subscription, но Novu push'и будут отклонены.
//
// Возвращает null, если ключ не сконфигурирован — потребитель деградирует
// gracefully (тумблер «Push в браузере» показывает «временно недоступно»,
// pre-prompt после онбординга не показывается).

export function getVapidPublicKey(): string | null {
	const key = import.meta.env.VITE_VAPID_PUBLIC_KEY as string | undefined;
	return typeof key === "string" && key.trim().length > 0 ? key.trim() : null;
}
